import { PdfTemplateSettings } from '@/components/settings/PdfTemplateSettings';
import { FileText } from 'lucide-react';
export default function PdfTemplateSettingsPage() {
  return <div className="container mx-auto p-4 md:p-6 max-w-7xl">
      <div className="flex items-center gap-4 mb-8">
        <div className="w-12 h-12 bg-gradient-to-br from-indigo-500 to-purple-600 rounded-lg flex items-center justify-center shadow-lg">
          <FileText className="w-6 h-6 text-white" />
        </div>
        <div>
          <h1 className="text-3xl font-bold tracking-tight">إعدادات نماذج PDF</h1>
          
        </div>
      </div>
      <PdfTemplateSettings />
    </div>;
}